/**
 * Whether Datavision POS is enabled for the logged-in customer (Admin UI).
 * Aligns with customer settings: customer.datavisionPosEnabled in DSOK details.
 */
export function isDatavisionPosEnabled(customer) {
  if (!customer || typeof customer !== "object") return false;
  if (customer.datavisionPosEnabled === true) return true;

  const raw = customer.dsokSettings;
  let parsed = raw;
  if (typeof raw === "string") {
    try {
      parsed = JSON.parse(raw);
    } catch {
      return false;
    }
  }
  return parsed?.customer?.datavisionPosEnabled === true;
}
